var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "100px",
    height: "100px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#c770f0",
    fillRule: "nonzero",
    stroke: "#c770f0",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,2c-12.6907,0 -23,10.3093 -23,23c0,12.69071 10.3093,23 23,23c12.69071,0 23,-10.30929 23,-23c0,-12.6907 -10.30929,-23 -23,-23zM25,4c11.60982,0 21,9.39018 21,21c0,11.60982 -9.39018,21 -21,21c-11.60982,0 -21,-9.39018 -21,-21c0,-11.60982 9.39018,-21 21,-21zM16,12c-1.64501,0 -3,1.35499 -3,3c0,1.64501 1.35499,3 3,3c1.64501,0 3,-1.35499 3,-3c0,-1.64501 -1.35499,-3 -3,-3zM16,14c0.56413,0 1,0.43587 1,1c0,0.56413 -0.43587,1 -1,1c-0.56413,0 -1,-0.43587 -1,-1c0,-0.56413 0.43587,-1 1,-1zM14,19c-0.55226,0.00006 -0.99994,0.44774 -1,1v15c0.00006,0.55226 0.44774,0.99994 1,1h4c0.55226,-0.00006 0.99994,-0.44774 1,-1v-15c-0.00006,-0.55226 -0.44774,-0.99994 -1,-1zM22,19c-0.55226,0.00006 -0.99994,0.44774 -1,1v15c0.00006,0.55226 0.44774,0.99994 1,1h4c0.55226,-0.00006 0.99994,-0.44774 1,-1v-7.5c0,-1.37955 1.12045,-2.5 2.5,-2.5c1.37955,0 2.5,1.12045 2.5,2.5v2.5v5c0.00006,0.55226 0.44774,0.99994 1,1h4c0.55226,-0.00006 0.99994,-0.44774 1,-1v-8.5c0,-4.13039 -3.36961,-7.5 -7.5,-7.5c-1.28647,0 -2.44026,0.41615 -3.5,0.99023c-0.00541,-0.54844 -0.45153,-0.99021 -1,-0.99023zM15,21h2v13h-2zM23,21h2v0.81641c0.00005,0.40093 0.23954,0.76309 0.60845,0.9201c0.36891,0.15701 0.79594,0.07853 1.08491,-0.19939c0.99083,-0.9518 2.32332,-1.53711 3.80664,-1.53711c3.04961,0 5.5,2.45039 5.5,5.5v7.5h-2v-4v-2.5c0,-2.47046 -2.02954,-4.5 -4.5,-4.5c-2.47046,0 -4.5,2.02954 -4.5,4.5v6.5h-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9e19f6e04cccb73a32e2467a57747ab2.svg";
export { ForwardRef as ReactComponent };